/* eslint-disable camelcase */
export type ImgArenaRequest = {
    url: string;
    clientId: number;
    timems: number;
    md5: string;
};

export type ImgArenaTokenResponse = {
    url: string;
    client_id: number;
    timestamp: number;
    access_token: string;
};

export type ImgArenaResponse = {
    success?: string;
    hlsUrl?: string;
};

export type ImgArenaError = {
    error?: unknown;
    message: string;
    code: string;
};

export function isImgArenaError(input: ImgArenaResponse | ImgArenaTokenResponse | ImgArenaError): input is ImgArenaError {
    return Boolean(((input as ImgArenaError).error || (input as ImgArenaError).code && (input as ImgArenaError).message));
}
